export const TIME_FORMAT = 'HH:mm';

export enum TimeCompareEn {
  LESS = -1,
  EQUAL = 0,
  GREATER = 1
}
